<template>
    <h1>This is the view to manage forms</h1>
    <FormsManagementTable />
</template>

<script setup>
import FormsManagementTable from '../../components/forms/FormsManagementTable.vue';


</script>